<header class="header-area p-relative">
  <!-- Top bar -->
  <div class="top-header top-header-pascani">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-md-8">
          <ul class="top-header-contact-info">
            <li>
              <a href="tel:0234XXXXXX">
                <i class="bx bx-phone-call"></i>
                0232761300
              </a>
            </li>
            <li>
              <a href="mailto:office@spital-pascani.ro">
                <i class="bx bx-envelope"></i>
                office@spital-pascani.ro
              </a>
            </li><!--
            <li class="d-none d-md-inline">
              <a href="#">
                <i class="bx bx-map"></i>
                Spitalul CF Pașcani
              </a>
            </li>-->
          </ul>
        </div>

        <div class="col-md-4">
          <div class="top-header-user d-flex justify-content-md-end align-items-center">
            <div class="user-avatar me-2">
              <span>{{ initials }}</span>
            </div>
            <button (click)="logout()" class="btn btn-sm btn-outline-light btn-logout btn-rounded">
              <i class="bx bx-log-out me-1"></i>
              Logout
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Navbar -->
  <div class="navbar-area navbar-pascani" >
    <div class="container">
      <nav class="navbar navbar-expand-lg navbar-light bg-white shadow-sm px-3" [class.active]="classApplied">
        <a class="navbar-brand d-flex align-items-center" routerLink="/">
          <img src="assets/img/logo.png" alt="">
          <span class="brand-text d-none d-md-inline px-2">Portal pacient <br> Pașcani</span>
        </a>

        <button class="navbar-toggler" type="button" (click)="toggleClass()" > 
          <span class="burger-menu">
            <span class="top-bar"></span>
            <span class="middle-bar"></span>
            <span class="bottom-bar"></span>
          </span>
        </button>

        <div class="collapse navbar-collapse" id="navbarSupportedContent">
          <ul class="navbar-nav ms-auto main-menu">
            <li class="nav-item">
              <a routerLink="/contul-meu"
                 class="nav-link"
                 routerLinkActive="active"
                 [routerLinkActiveOptions]="{ exact: true }">
                Contul meu
              </a>
            </li>
            <li class="nav-item">
              <a routerLink="/programari"
                 class="nav-link"
                 routerLinkActive="active"
                 [routerLinkActiveOptions]="{ exact: true }">
                Programări
              </a>
            </li>
            <li class="nav-item">
              <a routerLink="/rezultatele-mele"
                 class="nav-link"
                 routerLinkActive="active"
                 [routerLinkActiveOptions]="{ exact: true }">
                Rezultate
              </a>
            </li>
            <li class="nav-item">
              <a routerLink="/biletele-mele"
                 class="nav-link"
                 routerLinkActive="active"
                 [routerLinkActiveOptions]="{ exact: true }">
                Bilete
              </a>
            </li>
            <li class="nav-item">
              <a routerLink="/documentele-mele"
                 class="nav-link"
                 routerLinkActive="active"
                 [routerLinkActiveOptions]="{ exact: true }">
                Documente
              </a>
            </li>
          </ul>
        </div>
      </nav>
    </div>
  </div>
</header>
